export const isWebPaymentsEnabled =
  process.env.NEXT_PUBLIC_WEB_PAYMENTS_ENABLED !== 'false';
